import { useState } from 'react';

const useDialogHandler = (defaultOpen = false) => {
  const [isOpen, setIsOpen] = useState<boolean>(defaultOpen);

  const openDialog = () => setIsOpen(true);
  const closeDialog = () => setIsOpen(false);

  return { isOpen, openDialog, closeDialog };
};

export default useDialogHandler;
